import './index.css'
import App from  './App'
import ReactDom from 'react-dom/client'

let Root=ReactDom.createRoot(document.getElementById('root'));

Root.render(
    <App/>
);